import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { EventSalesAndAttendanceWrapper } from "../../components";

export default function EventSalesAndAttendancePage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <EventSalesAndAttendanceWrapper organization={organization} />
    </ModalProvider>
  );
}
